import { ExclamationCircleOutlined } from '@ant-design/icons';
import { notification } from 'antd';
import axios from 'axios';
import PropTypes from 'prop-types';
import { CREATE_SCOPING_CRON_JOB } from '../../../services';
import CustomButton from '../../Button';
import CustomModal from '../../Modal';

const RegexModal = (props) => {
	const {
		isModalOpen,
		setIsModelOpen,
		deleteView,
		setLoading,
		setPreviewLoading,
		regexFileData,
		updateRegexData,
		editView,
		formValues,
		scopeQueryString,
	} = props;

	const updateElasticRecords = () => {
		try {
			const query = {
				query: {
					bool: {
						must: [
							{
								match: {
									is_masked: false,
								},
							},
							{
								range: {
									masking_attempts_left: {
										gte: 0,
									},
								},
							},
						],
						must_not: [
							{
								match: {
									scoping_done: false,
								},
							},
						],
					},
				},
				script: {
					source:
						'ctx._source.scoping_done=false;ctx._source.scope_regexes=null;ctx._source.scope_word_list=null',
					lang: 'painless',
				},
			};

			/* istanbul ignore next */
			setTimeout(() => {
				axios
					.post(`/api/update-elastic-records`, {
						query,
						index: 'event_logs',
					})
					.then((res) => {
						const vc = res?.data?.elRes?.meta?.body?.version_conflicts;
						if (vc > 0) {
							updateElasticRecords();
						}
					})
					.catch((err) => {
						console.error(err);
					});
			}, 10000);
		} catch (err) {
			console.error(err);
		}
	};

	const stopCreateScopeCron = async () => {
		try {
			const res = await axios.post(`/api/stop-create-scopecron`);
			if (res) updateElasticRecords();
		} catch (err) {
			setPreviewLoading(false);
			setLoading(false);
			CREATE_SCOPING_CRON_JOB();
			console.error(err);
			notification.error({
				message: 'Something went wrong. Please try again later.',
			});
		}
	};

	// handle regex commit action and upload new data into minio bucket
	const handleRegexCommit = async () => {
		try {
			setLoading(true);
			setPreviewLoading(true);
			let fileStream = '';
			let newValues;
			if (editView?.state) {
				newValues = regexFileData.map((val) => {
					if (val.id === editView?.data?.id) {
						return formValues;
					} else {
						return val;
					}
				});
				fileStream = newValues;
			} else {
				newValues = [{ ...formValues }];
				fileStream = regexFileData.length ? [...newValues, ...regexFileData] : newValues;
			}
			if (fileStream) {
				if (scopeQueryString) {
					// const scopeQ = formValues?.scopeQuery;
					stopCreateScopeCron();
				}
				updateRegexData(fileStream, 'update');
			}
		} catch (err) {
			setPreviewLoading(false);
			setLoading(false);
		}
	};

	// delete regex item and update regex-data list
	const deleteRow = async () => {
		try {
			setLoading(true);
			let rowIndex;
			regexFileData.find((val, i) => {
				if (
					val.regex === deleteView?.data?.regex &&
					val.description === deleteView?.data?.description
				) {
					rowIndex = i;
				}
			});
			if (regexFileData[rowIndex]?.scopeQueryString) {
				stopCreateScopeCron();
			}

			regexFileData.splice(rowIndex, 1);

			updateRegexData(regexFileData, 'delete');
		} catch (err) {
			setLoading(false);
		}
	};

	return (
		<CustomModal
			isOpen={isModalOpen}
			className='successModal modal_wrapper'
			onClose={() => setIsModelOpen(false)}
			footer={[
				<CustomButton onClick={() => setIsModelOpen(false)} key='btnClose' id='btnClose'>
					{'No, Cancel'}
				</CustomButton>,

				<CustomButton
					className='r-commit'
					onClick={() => {
						deleteView?.state ? deleteRow() : handleRegexCommit();
						setIsModelOpen(false);
					}}
					type='primary'
					key='btndownload'
				>
					Yes, {deleteView?.state ? 'Delete' : 'Commit'}
				</CustomButton>,
			]}
		>
			<div className='success_modal'>
				<ExclamationCircleOutlined className='success-modal-icon' />
				<div className='success_modal_header'>Are you sure?</div>
				{!deleteView?.state && (
					<div className='success_modal_sub'>
						All redaction changes will be saved and will be used in the next newly masked images.
					</div>
				)}
			</div>
		</CustomModal>
	);
};

RegexModal.propTypes = {
	isModalOpen: PropTypes.bool,
	setIsModelOpen: PropTypes.func,
	deleteView: PropTypes.object,
	setLoading: PropTypes.func,
	setPreviewLoading: PropTypes.func,
	regexFileData: PropTypes.any,
	updateRegexData: PropTypes.func,
	editView: PropTypes.object,
	formValues: PropTypes.object,
	scopeQueryString: PropTypes.string,
};

export default RegexModal;
